import React from 'react';
import Hammer from 'hammerjs';
import classnames from 'classnames';
import { signatureRequestContext, zoomContext } from './context';
import styles from './document.scss';

class DocumentTargetDiv extends React.Component {

  handlePinch = (e) => {

    const { scaleZoom } = this.props;
    scaleZoom(e.type);

  };

  NOOP = () => {
    // this prevents weird pinch behavior
  };

  componentDidMount() {

    const { pageContainerRef } = this.props;

    this.hammer = new Hammer(pageContainerRef.current, {
      touchAction: 'pan-x pan-y',
    });
    this.hammer.get('pinch').set({ enable: true });
    this.hammer.on('pinchin', this.handlePinch);
    this.hammer.on('pinchout', this.handlePinch);
    this.hammer.on('pinchend pinchcancel', this.NOOP);

  }

  render() {

    const { className, noBackground, children } = this.props;

    return (
      <div className={classnames(styles.document, className, {
        [styles.noBackground]: noBackground,
      })}
        ref={this.props.setPageContainerRef}
      >

        {children}

      </div>
    );
  }

}

function DocumentTargetWrap(props) {

  const { pageContainerRef, setPageContainerRef } = React.useContext(signatureRequestContext);
  const { scaleZoom } = React.useContext(zoomContext);

  return (
    <DocumentTargetDiv
      {...props}
      pageContainerRef={pageContainerRef}
      setPageContainerRef={setPageContainerRef}
      scaleZoom={scaleZoom} />
  );

}

export default DocumentTargetWrap;
